
const triggerProductApi = (sessionId, sendCountry, receiveCountry,language, amount, fundsIn, fundsOut, getBestFxWithoutFiFo=true, destinationCurrency, channel , client) => {
  const headersProductApi = new Headers();
  const sendCountryUpperCase = sendCountry.toUpperCase();
  headersProductApi.append("x-wu-operationname", "products");
  headersProductApi.append("Content-Type", "application/json");
  headersProductApi.append("x-wu-accesscode", "RtYV3XDz9EA");
  headersProductApi.append("wucountrycode", sendCountryUpperCase);
  headersProductApi.append("wulanguagecode", language);
  headersProductApi.append('device-id', CookieService?.getCookie('wu_device_id'))
  let payOut = receiveCountry.toUpperCase() === 'MX' && fundsOut === 'AG' ? CloudPayOutCodeMapping['AGMexico'] : CloudPayOutCodeMapping[fundsOut]
  const dateNow = Date.now();
  let pageState = window.sessionStorage.getItem('state')
  let stateProviceInfo = {};
  if (["CA","US"].includes(sendCountryUpperCase)) {
    if(pageState) {
      pageState = JSON.parse(pageState);
      if (
        pageState?.updatedUserDetails?.gatewayCustomer?.address?.state
        && pageState?.updatedUserDetails?.gatewayCustomer?.address?.province
      ) {
        stateProviceInfo['eflValue'] = pageState.updatedUserDetails.gatewayCustomer.address.state
        stateProviceInfo['provinceState'] = pageState.updatedUserDetails.gatewayCustomer.address.province
      }
    } else {
      const AKRegioncode = CookieService.getCookie('AKRegioncode')
      if (AKRegioncode) {
        stateProviceInfo['eflValue'] = stateProviceInfo['provinceState'] = AKRegioncode
      }
    }
    if (!(stateProviceInfo['eflValue'] && 
        ((sendCountryUpperCase === 'CA') && CanadaStates[stateProviceInfo['eflValue']]) ||
        ((sendCountryUpperCase === 'US') && USAStates[stateProviceInfo['eflValue']])
        )) {
        stateProviceInfo = {}
    }
  }
  const customerId = window.sessionStorage.getItem('AccountNumber');
  const addVisitorAttr = () => (
      customerId &&
      { 
          visitor: {
              customerId: customerId
          }
      }
  );
  let amountCalculated = (amount * 100).toFixed(2)
  amountCalculated = Number(amountCalculated)
  
  const productVariables = {
    "req_products": {
      "origination": {
        "channel": channel || 'WWEB',
        "client": client || 'WUCOM',
        "countryIsoCode": sendCountryUpperCase,
        "currencyIsoCode": ISO_CODES_COUNTRIES_CURRENCIES[sendCountryUpperCase],
        "eflType": "STATE",
        "amount": amountCalculated,
        "fundsIn": "*",
        "airRequested": "Y",
        ...stateProviceInfo
      },
      "destination": {
        "countryIsoCode": receiveCountry.toUpperCase(),
        "currencyIsoCode": destinationCurrency ? destinationCurrency : ISO_CODES_COUNTRIES_CURRENCIES[receiveCountry.toUpperCase()]
      },
      language,
      "headerRequest": {
        "version": "0.5",
        "requestType": "PRICECATALOG",
        "correlationId": sessionId,
        "transactionId": `${sessionId}-${dateNow}`
      },
      "visit": {
        "localDatetime": {
          "timeZone": new Date().getTimezoneOffset(),
          "timestampMs": dateNow
        }
      },
      ...addVisitorAttr()
    }
  };
  const graphql = JSON.stringify({
    query: productApiQuery,
    variables: productVariables
  })
  const requestOptions = {
    method: 'POST',
    headers: headersProductApi,
    body: graphql,
    redirect: 'follow'
  };
  
  return fetch(routerUrl, requestOptions)
    .then(response => response.text())
    .then(result => {
      result = JSON.parse(result);
      if (getBestFxWithoutFiFo) {
        const categories = result?.data?.products?.categories || [];
        const priority = (sendCountryUpperCase === 'CA') ? ['bestratefee', 'bestvalue', 'fastest'] : ['bestfxfee', 'fastest', 'bestvalue'];
        let selectedCategory = null;
        for (let p of priority) {
          selectedCategory = categories.find(({type}) => type && type.toLowerCase().replace(/\s|\+|-/g, '') === p);
          if (selectedCategory) break;
        }
        if (!selectedCategory || !selectedCategory.orders || selectedCategory.orders.length === 0) {
          fundsIn = result?.data?.products?.products[0].payIn;
          payOut = result?.data?.products?.products[0].payOut;
        } else {
          fundsIn = selectedCategory.orders[0].payIn;
          payOut = selectedCategory.orders[0].payOut;
        }
      }
      let foundResult = result?.data?.products?.products?.filter((product) => {
        return product.payIn === fundsIn && (payOut === '801' ? product.code === payOut : product.payOut === payOut); // The 801 is for China, will remove this later
      })
      foundResult = foundResult?.length > 0 ? foundResult[0] : (result?.data?.products?.products && result.data.products.products[0])
      if (foundResult){
        const strike_fee = foundResult.strikeFees && ((foundResult.strikeFees)/100 )
        let fundsOut;
        for (let payOutType in CloudPayOutCodeMapping) {
          if (CloudPayOutCodeMapping[payOutType] === payOut) {
            fundsOut = payOutType.split("_")[0]
          }
        }
        return Promise.resolve({
          fx: foundResult.exchangeRate,
          strike_fee,
          strikeReceiveAmount: calcAmt({
            strike_fee,
            strike_fx_rate: foundResult.strikeExchangeRate}, {
              sendAmount: amount
            }, true),
          strike_fx_rate: foundResult.strikeExchangeRate,
          fee: foundResult.fees ? foundResult.fees / 100 : 0,
          receiveAmount: foundResult?.destination?.expectedPayoutAmountLong
            ? foundResult.destination.expectedPayoutAmountLong / 100
            : 0,
          sendAmount: amount,
          fundsIn,
          payOut,
          selectedFundsOut: fundsOut,
          selectedFundsIn: CloudPayIn[fundsIn?.toUpperCase()]
        });
      } else {
        return Promise.resolve({
          fx: null,
          fee: null,
          receiveAmount: 0,
          sendAmount: 0,
          fundsIn,
          payOut,
        });
      }
    })
    .catch(error => console.log('error', error));
}